module.exports = __webpack_public_path__ + "img/logo.86b173d4.png";